export class DateTimeDimensionReferenceModel {
    public dateTimeDimensionCode: string; 
    public dateTimeDimensionName: string; 
    public sortSequence: number;
    public statusCode: string;    
}